"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

// Source: /frontend/js/src/preact-components/assets/animated-loader.tsx

/**
 * CSS-based animated loading component with three bouncing dots
 * Uses the 'animated-loader' class that provides CSS animations
 * This is for more complex loading states compared to the simple Loader component
 */
var AnimatedLoader = function AnimatedLoader() {
  return (0, _preact.h)("div", {
    className: "animated-loader"
  }, (0, _preact.h)("div", null), (0, _preact.h)("div", null), (0, _preact.h)("div", null));
};

var _default = AnimatedLoader;
exports.default = _default;